import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ShipmentVarietySizeASN } from '../model/ShipmentVarietySizeASN';

@Injectable()
export class ShipmentVarietySizeASNService {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetCollectionByManifestId(manifestId: number): Observable<RequestResponse<ShipmentVarietySizeASN[]>> {
        return this._httpClient.get<RequestResponse<ShipmentVarietySizeASN[]>>(this._urlBase + 'api/ShipmentVarietySizeASN/GetCollectionByManifestId?manifestId=' + manifestId);
    }
}